import { IEventData } from 'meta/pages/v4/event'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'

type Props = {
  idOrCodeUrl: string
}

type Response = IEventData

export const getData = async (props: Props): Promise<Response> => {
  const { idOrCodeUrl } = props

  const endpoint = ApiEndpoint.v4.event.data(idOrCodeUrl)

  const { data } = await HttpRequestForApiV4.get<Response>(endpoint)
  return data
}
